module.exports = __webpack_public_path__ + "media/images/interview_screen-95dd2d4c28d1625004997cd9cee4a05c.svg";